export type HeaderLike = Headers | Record<string, unknown> | undefined;

function readHeader(headers: HeaderLike, name: string): string | undefined {
  if (!headers) return undefined;
  if (typeof Headers !== 'undefined' && headers instanceof Headers) {
    const value = headers.get(name);
    return value === null ? undefined : value;
  }
  const record = headers as Record<string, unknown>;
  return (record[name] as string | undefined) || (record[name.toLowerCase()] as string | undefined) || undefined;
}

function parseJsonLike(value: unknown): unknown {
  if (typeof value !== 'string') return value;
  const trimmed = value.trim();
  if (!trimmed || (!trimmed.startsWith('{') && !trimmed.startsWith('['))) return value;
  try {
    return JSON.parse(trimmed);
  } catch {
    return value;
  }
}

function fromObject(value: unknown): string | undefined {
  if (!value || typeof value !== 'object') return undefined;
  const r = value as Record<string, unknown>;
  const direct =
    (r.traceId as string | undefined) || (r.traceID as string | undefined) || (r.errorId as string | undefined);
  if (direct) return direct;
  const ext = r.extensions as Record<string, unknown> | undefined;
  return ext ? (ext.traceId as string | undefined) || (ext.errorId as string | undefined) || undefined : undefined;
}

/** Body-first (CORS-immune), then x-cloud-trace-context header. */
export function getTraceId(input: { body?: unknown; headers?: HeaderLike }): string | undefined {
  return fromObject(parseJsonLike(input.body)) || readHeader(input.headers, 'x-cloud-trace-context');
}
